import { render, staticRenderFns } from "./CreateQuote.vue?vue&type=template&id=c13dfd20&scoped=true&"
import script from "./CreateQuote.vue?vue&type=script&lang=js&"
export * from "./CreateQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13dfd20",
  null
  
)

export default component.exports